// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
// сервер сменил константу с byte = -1; на byte = -2
export let InstrumentTradingBalance = 
{
    SETTLEMENT_IMMEDIATE: 254,
    SETTLEMENT_T_PLUS: 255 // T+0 (today)
};

Object.freeze(InstrumentTradingBalance);